exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".boyutSpan[data-v-3529a76b]{width:125px}", ""]);

// exports
